import React, { useEffect, useMemo, useState } from 'react';
import { dateToDateString } from '../../etc/etcfunctions';
import { DataGridPremium, GridFilterModel, GridRowModel } from '@mui/x-data-grid-premium';
import { dayNumberToKorean, englishLocationToKorean, koreanLocationToEnglish } from '../../../../../data/locationFuntion';
import { Button, Select, Option, Modal, ModalDialog, FormControl, Input } from '@mui/joy';
import { toast } from 'react-toastify';
import { ToggleButton, ToggleButtonGroup, SwipeableDrawer, Autocomplete, TextField, Backdrop, CircularProgress } from '@mui/material';

import totalLocationData from '../../../../../data/locationdata';
import { getFetch, postFetch } from '../../../../../fetch/fetch';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChatForOpinion from '../../chatforOpinion';
import ConsultStatsModal from './consultstatsmodal';
import CustomInput from '../../etc/custominput';

const bookingColumns = [
    { field: "kindLabel", headerName: "종류", width: 90 },
    { field: "location", headerName: "지점", width: 100, filterable: true },
    { field: "date", headerName: "예약일", width: 150 },
    { field: "time", headerName: "예약시간", width: 150 },
    { field: "name", headerName: "이름", width: 100 },
    { field: "phone", headerName: "전화번호", width: 150 },
    { field: "memo", headerName: "메모", width: 200, editable: true },
];

// totalLocationData에서 전체(total) 제외한 지점 목록
const visitLocationOptions = totalLocationData
    .filter((l: any) => l.english !== 'total')
    .map((l: any) => ({ korean: l.korean, english: l.english }));

const getTodayStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const transformWalkinRow = (each: any) => {
    const row: any = {};
    row.id = "w" + each.id;
    row.walkinId = each.id;
    row.isWalkin = true;
    row.kindRaw = 0;
    row.location = englishLocationToKorean(each.location) || each.location || '';

    const date = each.consultDate ? new Date(each.consultDate) : new Date();
    const hours = Math.floor((each.timeMinutes || 0) / 60);
    const minutes = (each.timeMinutes || 0) % 60;

    row.dateData = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
    row.timeNumber = row.dateData.getTime();
    row.date = dateToDateString(date) + ` (${dayNumberToKorean(date.getDay())})`;

    const ampm = hours >= 12 ? "오후" : "오전";
    const displayHours = hours > 12 ? hours - 12 : (hours === 0 ? 12 : hours);
    row.time = `${ampm} ${displayHours}시` + (minutes > 0 ? ` ${minutes}분` : '');
    row.name = each.consultantName || '';
    row.phone = each.phoneNumber || '';
    row.memo = each.memo || '';
    row.kindLabel = '워크인';
    return row;
};

const VisitConsult: React.FC<any> = (props) => {

    const [visitRows, setVisitRows] = useState<any[]>([]);
    const [walkinRows, setWalkinRows] = useState<any[]>([]);
    const [enrichmentData, setEnrichmentData] = useState<Record<string, any>>({});
    const [selectedRowId, setSelectedRowId] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [autoMatchLoading, setAutoMatchLoading] = useState(false);
    const [statsModalType, setStatsModalType] = useState<'location' | 'assignee' | null>(null);
    const [alignment, setAlignment] = useState('total');

    // 워크인 추가 Modal에서 쓸 지점 목록 (user와 같은 academy만)
    const filteredLocations = useMemo(() => {
        return totalLocationData.filter((l: any) =>
            l.english !== 'total' &&
            Array.isArray(l.academy) &&
            l.academy.includes(props.user?.academy)
        );
    }, [props.user?.academy]);
    const [alignment2, setAlignment2] = useState('current');
    const [myConsultFilter, setMyConsultFilter] = useState(false);
    const [assigneeSearch, setAssigneeSearch] = useState('');
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [{ id: 2, field: 'location', operator: 'contains', value: "" }],
    });

    // 댓글 Drawer
    const [commentDrawerOpen, setCommentDrawerOpen] = useState(false);
    const [selectedCommentVisitConsultId, setSelectedCommentVisitConsultId] = useState<number | null>(null);
    const [selectedCommentTitle, setSelectedCommentTitle] = useState('');

    // 워크인 추가 Modal
    const [addWalkinOpen, setAddWalkinOpen] = useState(false);
    const [walkinForm, setWalkinForm] = useState({ location: '', date: getTodayStr(), hour: 9, minute: 0, name: '', phone: '010' });

    // 학생연결하기 Modal
    const [matchModalOpen, setMatchModalOpen] = useState(false);
    const [selectedMatchRow, setSelectedMatchRow] = useState<any>(null);
    const [matchStudents, setMatchStudents] = useState<any[]>([]);
    const [selectedMatchStudent, setSelectedMatchStudent] = useState<any>(null);

    // 수동 배정하기 Modal
    const [manualAssignOpen, setManualAssignOpen] = useState(false);
    const [manualAssignRow, setManualAssignRow] = useState<any>(null);
    const [teacherList, setTeacherList] = useState<any[]>([]);
    const [selectedTeacher, setSelectedTeacher] = useState<any>(null);

    // 등록 인센티브 Modal
    const [incentiveModalOpen, setIncentiveModalOpen] = useState(false);
    const [selectedIncentiveRow, setSelectedIncentiveRow] = useState<any>(null);
    const [incentiveAmount, setIncentiveAmount] = useState(5000);
    const [incentiveDate, setIncentiveDate] = useState(getTodayStr());

    // 대기 학생 매칭 Modal
    const [waitingMatchModalOpen, setWaitingMatchModalOpen] = useState(false);
    const [waitingMatchCandidates, setWaitingMatchCandidates] = useState<any[]>([]);
    const [selectedWaitingCandidate, setSelectedWaitingCandidate] = useState<any>(null);
    const [selectedWaitingMatchRow, setSelectedWaitingMatchRow] = useState<any>(null);

    // 대기 인센티브 Modal
    const [waitingIncentiveModalOpen, setWaitingIncentiveModalOpen] = useState(false);
    const [selectedWaitingIncentiveRow, setSelectedWaitingIncentiveRow] = useState<any>(null);
    const [waitingIncentiveAmount, setWaitingIncentiveAmount] = useState(2000);
    const [waitingIncentiveDate, setWaitingIncentiveDate] = useState(getTodayStr());

    // 방문상담 최종 표시 rows
    const displayVisitRows = useMemo(() => {
        const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        const filteredWalkins = walkinRows.filter(r => {
            if (!r.dateData) return false;
            return alignment2 === 'current'
                ? r.dateData.getTime() >= today.getTime()
                : r.dateData.getTime() < today.getTime();
        });
        let rows = [...visitRows, ...filteredWalkins];
        rows.sort((a: any, b: any) =>
            alignment2 === 'current' ? a.timeNumber - b.timeNumber : b.timeNumber - a.timeNumber
        );
        if (myConsultFilter) {
            rows = rows.filter(r => enrichmentData[String(r.id)]?.assignedUserId === props.user?.id);
        }
        if (assigneeSearch) {
            rows = rows.filter(r => {
                const name = enrichmentData[String(r.id)]?.assignedUserName || '';
                return name.includes(assigneeSearch);
            });
        }
        return rows;
    }, [visitRows, walkinRows, alignment2, myConsultFilter, assigneeSearch, enrichmentData, props.user]);

    const loadEnrichment = async (ids: number[]) => {
        if (!ids.length) return;
        try {
            const result: any = await getFetch(`/dashboard/report/visitConsultEnrichment?ids=${ids.join(',')}`);
            if (result.message === 'success') {
                const newMap: Record<string, any> = {};
                result.data.forEach((each: any) => {
                    newMap[String(each.externalBookingId)] = {
                        visitConsultId: each.id,
                        assignedUserId: each.assignedUserId,
                        assignedUserName: each.assignedUserName,
                        consultStatus: each.consultStatus ?? 0,
                        matchedStudentId: each.matchedStudentId,
                        matchedStudentName: each.matchedStudentName,
                        commentCount: each.commentCount ?? 0,
                        incentiveId: each.incentiveId,
                        incentiveAddedAt: each.incentiveAddedAt,
                        incentiveAddedByName: each.incentiveAddedByName,
                        waitingMatchId: each.waitingMatchId,
                        waitingMatchName: each.waitingMatchName,
                        waitingMatchCreatedAt: each.waitingMatchCreatedAt,
                        waitingIncentiveId: each.waitingIncentiveId,
                        waitingIncentiveAddedAt: each.waitingIncentiveAddedAt,
                        waitingIncentiveAddedByName: each.waitingIncentiveAddedByName,
                        waitingIncentiveAmount: each.waitingIncentiveAmount,
                    };
                });
                setEnrichmentData(prev => ({ ...prev, ...newMap }));
            }
        } catch (e) {}
    };

    const loadWalkins = async () => {
        try {
            const result: any = await getFetch('/dashboard/report/visitConsultWalkins');
            if (result.message === 'success') {
                setWalkinRows(result.data.map(transformWalkinRow));
                const newMap: Record<string, any> = {};
                result.data.forEach((each: any) => {
                    newMap["w" + each.id] = {
                        visitConsultId: each.id,
                        assignedUserId: each.assignedUserId,
                        assignedUserName: each.assignedUserName,
                        consultStatus: each.consultStatus ?? 0,
                        matchedStudentId: each.matchedStudentId,
                        matchedStudentName: each.matchedStudentName,
                        commentCount: each.commentCount ?? 0,
                        incentiveId: each.incentiveId,
                        incentiveAddedAt: each.incentiveAddedAt,
                        incentiveAddedByName: each.incentiveAddedByName,
                        waitingMatchId: each.waitingMatchId,
                        waitingMatchName: each.waitingMatchName,
                        waitingMatchCreatedAt: each.waitingMatchCreatedAt,
                        waitingIncentiveId: each.waitingIncentiveId,
                        waitingIncentiveAddedAt: each.waitingIncentiveAddedAt,
                        waitingIncentiveAddedByName: each.waitingIncentiveAddedByName,
                        waitingIncentiveAmount: each.waitingIncentiveAmount,
                    };
                });
                setEnrichmentData(prev => ({ ...prev, ...newMap }));
            }
        } catch (e) {}
    };

    const loadMatchStudents = async () => {
        try {
            const result: any = await getFetch('/dashboard/restaurant/users');
            if (result.data) {
                setMatchStudents(result.data.map((each: any) => ({
                    label: `${each.name}(${each.location})(${each.id})`,
                    id: each.id,
                })));
            }
        } catch (e) {}
    };

    const loadTeachers = async () => {
        try {
            const result: any = await getFetch('/dashboard/report/visitConsultTeachers');
            if (result.data) {
                setTeacherList(result.data.map((u: any) => ({
                    label: `${u.name}`,
                    id: u.id,
                    name: u.name,
                })));
            }
        } catch (e) {}
    };

    const submitManualAssign = async () => {
        if (!selectedTeacher || !manualAssignRow) return;
        try {
            let result: any;
            if (manualAssignRow.isWalkin) {
                result = await postFetch('/dashboard/report/visitConsultWalkinAssignManual', {
                    walkinId: manualAssignRow.walkinId,
                    targetUserId: selectedTeacher.id,
                    targetUserName: selectedTeacher.name,
                });
            } else {
                result = await postFetch('/dashboard/report/visitConsultAssignManual', {
                    externalBookingId: manualAssignRow.id,
                    targetUserId: selectedTeacher.id,
                    targetUserName: selectedTeacher.name,
                });
            }
            if (result.message === 'success') {
                setManualAssignOpen(false);
                setEnrichmentData(prev => ({
                    ...prev,
                    [String(manualAssignRow.id)]: {
                        ...(prev[String(manualAssignRow.id)] || {}),
                        assignedUserId: selectedTeacher.id,
                        assignedUserName: selectedTeacher.name,
                    }
                }));
                manualAssignRow.isWalkin ? loadWalkins() : loadEnrichment([manualAssignRow.id]);
            }
        } catch (e) {}
    };

    const getBookedList = async () => {
        try {
            const result: any = await postFetch("/dashboard/report/bookingTotalData", {});
            const data = result.data;
            var newRows: any = [];

            data.forEach((each: any) => {
                if (each.kind !== 0) return;

                const oneRow: any = {};
                oneRow.id = each.id;
                oneRow.location = englishLocationToKorean(each.location);

                const date = new Date(each.date);
                oneRow.date = dateToDateString(date) + ` (${dayNumberToKorean(date.getDay())})`;

                var ampm = "오전";
                var hours = Math.floor(each.time / 60);
                var minutes = each.time % 60;
                const realDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
                oneRow.dateData = realDate;

                if (hours >= 12) {
                    ampm = "오후";
                    if (hours > 12) hours -= 12;
                }
                oneRow.time = `${ampm} ${hours}시` + (minutes > 0 ? ` ${minutes}분` : '');
                oneRow.name = each.name;
                oneRow.memo = each.memo;
                oneRow.phone = each.telephoneNumber;
                oneRow.timeNumber = realDate.getTime();
                oneRow.isWalkin = false;
                oneRow.kindLabel = '상담예약';

                newRows.push(oneRow);
            });

            const current = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
            if (alignment2 === "current") {
                newRows = newRows.filter((r: any) => r.dateData.getTime() >= current.getTime());
            } else {
                newRows = newRows.filter((r: any) => r.dateData.getTime() < current.getTime());
            }
            newRows.sort((a: any, b: any) =>
                alignment2 === "current" ? a.timeNumber - b.timeNumber : b.timeNumber - a.timeNumber
            );

            setVisitRows(newRows);

            const visitIds = newRows.map((r: any) => r.id);
            if (visitIds.length > 0) loadEnrichment(visitIds);
        } catch (e) {}
    };

    useEffect(() => {
        getBookedList();
    }, [alignment2]);

    useEffect(() => {
        loadWalkins();
        loadMatchStudents();
        loadTeachers();
    }, []);

    const assignConsult = async (row: any) => {
        try {
            let result: any;
            if (row.isWalkin) {
                result = await postFetch('/dashboard/report/visitConsultWalkinAssign', { walkinId: row.walkinId });
            } else {
                result = await postFetch('/dashboard/report/visitConsultAssign', { externalBookingId: row.id });
            }
            if (result.message === 'success') {
                row.isWalkin ? loadWalkins() : loadEnrichment([row.id]);
            }
        } catch (e) {}
    };

    const unassignConsult = async (visitConsultId: number, rowId: any) => {
        try {
            const result: any = await postFetch('/dashboard/report/visitConsultUnassign', { visitConsultId });
            if (result.message === 'success') {
                String(rowId).startsWith('w') ? loadWalkins() : loadEnrichment([rowId]);
            }
        } catch (e) {}
    };

    const updateConsultStatus = async (row: any, status: number) => {
        setEnrichmentData(prev => ({
            ...prev,
            [String(row.id)]: { ...(prev[String(row.id)] || {}), consultStatus: status }
        }));
        try {
            if (row.isWalkin) {
                await postFetch('/dashboard/report/visitConsultWalkinStatus', { walkinId: row.walkinId, status });
            } else {
                await postFetch('/dashboard/report/visitConsultStatus', { externalBookingId: row.id, status });
            }
        } catch (e) {}
    };

    const openCommentDrawer = async (row: any) => {
        const e = enrichmentData[String(row.id)];
        if (row.isWalkin) {
            setSelectedCommentVisitConsultId(row.walkinId);
            setSelectedCommentTitle(row.name);
            setCommentDrawerOpen(true);
        } else if (e?.visitConsultId) {
            setSelectedCommentVisitConsultId(e.visitConsultId);
            setSelectedCommentTitle(row.name);
            setCommentDrawerOpen(true);
        } else {
            try {
                const result: any = await postFetch('/dashboard/report/visitConsultInit', { externalBookingId: row.id });
                if (result.message === 'success') {
                    setEnrichmentData(prev => ({
                        ...prev,
                        [String(row.id)]: { ...(prev[String(row.id)] || {}), visitConsultId: result.visitConsultId }
                    }));
                    setSelectedCommentVisitConsultId(result.visitConsultId);
                    setSelectedCommentTitle(row.name);
                    setCommentDrawerOpen(true);
                }
            } catch (e) {}
        }
    };

    const openMatchModal = (row: any) => {
        setSelectedMatchRow(row);
        setSelectedMatchStudent(null);
        setMatchModalOpen(true);
    };

    const resetMatch = async (visitConsultId: number, rowId: any) => {
        try {
            const result: any = await postFetch('/dashboard/report/visitConsultMatchReset', { visitConsultId });
            if (result.message === 'success') {
                setEnrichmentData(prev => ({
                    ...prev,
                    [String(rowId)]: { ...(prev[String(rowId)] || {}), matchedStudentId: null, matchedStudentName: null }
                }));
                String(rowId).startsWith('w') ? loadWalkins() : loadEnrichment([+rowId]);
            }
        } catch (e) {}
    };

    const submitMatch = async () => {
        if (!selectedMatchStudent || !selectedMatchRow) return;
        const studentId = selectedMatchStudent.id;
        const studentName = selectedMatchStudent.label.split('(')[0].trim();
        try {
            let result: any;
            if (selectedMatchRow.isWalkin) {
                result = await postFetch('/dashboard/report/visitConsultWalkinMatch', {
                    walkinId: selectedMatchRow.walkinId, studentId, studentName,
                });
            } else {
                result = await postFetch('/dashboard/report/visitConsultMatch', {
                    externalBookingId: selectedMatchRow.id, studentId, studentName,
                });
            }
            if (result.message === 'success') {
                setMatchModalOpen(false);
                setEnrichmentData(prev => ({
                    ...prev,
                    [String(selectedMatchRow.id)]: {
                        ...(prev[String(selectedMatchRow.id)] || {}),
                        matchedStudentId: studentId,
                        matchedStudentName: studentName,
                    }
                }));
                selectedMatchRow.isWalkin ? loadWalkins() : loadEnrichment([selectedMatchRow.id]);
                toast.success('매칭 성공!', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            }
        } catch (e) {}
    };

    const handleWalkinPhoneChange = (raw: string) => {
        let digits = raw.replace(/\D/g, "");
        if (!digits.startsWith("010")) {
            if (digits.length <= 3) {
                digits = "010";
            } else {
                digits = "010" + digits.slice(3);
            }
        }
        if (digits.length < 3) digits = "010";
        if (digits.length > 11) digits = digits.slice(0, 11);
        let formatted = "";
        if (digits.length <= 3) {
            formatted = digits;
        } else if (digits.length <= 7) {
            formatted = digits.slice(0, 3) + "-" + digits.slice(3);
        } else {
            formatted = digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
        }
        setWalkinForm(prev => ({ ...prev, phone: formatted }));
    };

    // 대기학생 신청시각이 상담 예약 슬롯 시각보다 이전이면 true (= 상담이 만들어낸 대기가 아니므로 인센티브 대상 아님)
    const isWaitingBeforeConsult = (e: any, row: any) => {
        if (!e?.waitingMatchCreatedAt || !row?.timeNumber) return false;
        return new Date(e.waitingMatchCreatedAt).getTime() < row.timeNumber;
    };

    const openIncentiveModal = (row: any) => {
        if (!props.user?.todoistApiKey) {
            toast.error('본사 담당자만 부여 가능합니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            return;
        }
        // 같은 행에 대기 인센티브가 이미 부여돼 있으면 등록 디폴트 = 5000 - 대기금액 (합계 5000원)
        const e = enrichmentData[String(row.id)];
        const waitingAmount = e?.waitingIncentiveId ? (Number(e.waitingIncentiveAmount) || 0) : 0;
        const defaultAmount = waitingAmount > 0 ? Math.max(0, 5000 - waitingAmount) : 5000;
        setSelectedIncentiveRow(row);
        setIncentiveAmount(defaultAmount);
        setIncentiveDate(getTodayStr());
        setIncentiveModalOpen(true);
    };

    const submitIncentive = async () => {
        if (!selectedIncentiveRow) return;
        const e = enrichmentData[String(selectedIncentiveRow.id)];
        if (!e?.assignedUserId) return;

        const matchedStudentName = e.matchedStudentName || '학생';
        const assignedUserName = e.assignedUserName || '';
        const systemNote = `${matchedStudentName} 방문상담 등록(${assignedUserName})`;

        try {
            const addResult: any = await postFetch('/dashboard/salary/addincentive', {
                userId: e.assignedUserId,
                date: new Date(incentiveDate).getTime(),
                description: '방문상담 인센티브',
                amount: incentiveAmount,
                systemNote,
            });

            if (addResult.message !== 'success') return;
            const insertId = addResult.insertId;

            if (selectedIncentiveRow.isWalkin) {
                await postFetch('/dashboard/report/visitConsultIncentiveMark', {
                    walkinId: selectedIncentiveRow.walkinId,
                    incentiveId: insertId,
                    addedByName: props.user?.name || '',
                });
            } else {
                await postFetch('/dashboard/report/visitConsultIncentiveMark', {
                    externalBookingId: selectedIncentiveRow.id,
                    incentiveId: insertId,
                    addedByName: props.user?.name || '',
                });
            }

            setIncentiveModalOpen(false);
            toast.success('인센티브가 부여되었습니다!', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });

            if (selectedIncentiveRow.isWalkin) loadWalkins();
            else loadEnrichment([selectedIncentiveRow.id]);
        } catch (err) {}
    };

    const cancelIncentive = async (incentiveId: number, row: any) => {
        if (!window.confirm('인센티브를 취소하시겠습니까? 급여 내역에서도 삭제됩니다.')) return;
        try {
            await postFetch('/dashboard/salary/deleteincentive', { incentiveId });
            if (row.isWalkin) {
                await postFetch('/dashboard/report/visitConsultIncentiveClear', { walkinId: row.walkinId });
                loadWalkins();
            } else {
                await postFetch('/dashboard/report/visitConsultIncentiveClear', { externalBookingId: row.id });
                loadEnrichment([row.id]);
            }
            toast.success('인센티브가 취소되었습니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
        } catch (err) {}
    };

    // 대기 학생 매칭
    const openWaitingMatchModal = async (row: any) => {
        const consultDate = row.dateData
            ? `${new Date(row.dateData).getFullYear()}-${String(new Date(row.dateData).getMonth()+1).padStart(2,'0')}-${String(new Date(row.dateData).getDate()).padStart(2,'0')}`
            : getTodayStr();
        try {
            const result: any = await getFetch(`/dashboard/report/visitConsultWaitingCandidates?consultDate=${consultDate}`);
            if (result.message === 'success') {
                if (!result.data?.length) {
                    toast.info('해당 기간 내 대기 신청자가 없습니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
                    return;
                }
                const candidates = result.data.map((each: any) => ({
                    label: `${each.name}(${englishLocationToKorean(each.location) || each.location})(${each.phoneNumber})(${each.createdAt?.slice(0, 10)})`,
                    id: each.id,
                    name: each.name,
                }));
                setWaitingMatchCandidates(candidates);
                setSelectedWaitingCandidate(null);
                setSelectedWaitingMatchRow(row);
                setWaitingMatchModalOpen(true);
            }
        } catch (e) {}
    };

    const submitWaitingMatch = async () => {
        if (!selectedWaitingCandidate || !selectedWaitingMatchRow) return;
        try {
            let result: any;
            if (selectedWaitingMatchRow.isWalkin) {
                result = await postFetch('/dashboard/report/visitConsultWaitingMatch', {
                    walkinId: selectedWaitingMatchRow.walkinId,
                    waitingId: selectedWaitingCandidate.id,
                    waitingName: selectedWaitingCandidate.name,
                });
            } else {
                result = await postFetch('/dashboard/report/visitConsultWaitingMatch', {
                    externalBookingId: selectedWaitingMatchRow.id,
                    waitingId: selectedWaitingCandidate.id,
                    waitingName: selectedWaitingCandidate.name,
                });
            }
            if (result.message === 'success') {
                setWaitingMatchModalOpen(false);
                setEnrichmentData(prev => ({
                    ...prev,
                    [String(selectedWaitingMatchRow.id)]: {
                        ...(prev[String(selectedWaitingMatchRow.id)] || {}),
                        waitingMatchId: selectedWaitingCandidate.id,
                        waitingMatchName: selectedWaitingCandidate.name,
                    }
                }));
                selectedWaitingMatchRow.isWalkin ? loadWalkins() : loadEnrichment([selectedWaitingMatchRow.id]);
            }
        } catch (e) {}
    };

    const resetWaitingMatch = async (row: any) => {
        try {
            let result: any;
            if (row.isWalkin) {
                result = await postFetch('/dashboard/report/visitConsultWaitingMatchReset', { walkinId: row.walkinId });
            } else {
                result = await postFetch('/dashboard/report/visitConsultWaitingMatchReset', { externalBookingId: row.id });
            }
            if (result.message === 'success') {
                setEnrichmentData(prev => ({
                    ...prev,
                    [String(row.id)]: { ...(prev[String(row.id)] || {}), waitingMatchId: null, waitingMatchName: null }
                }));
                row.isWalkin ? loadWalkins() : loadEnrichment([row.id]);
            }
        } catch (e) {}
    };

    // 대기 인센티브
    const openWaitingIncentiveModal = (row: any) => {
        if (!props.user?.todoistApiKey) {
            toast.error('todoistApiKey 있는 계정만 부여 가능합니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            return;
        }
        setSelectedWaitingIncentiveRow(row);
        setWaitingIncentiveAmount(2000);
        setWaitingIncentiveDate(getTodayStr());
        setWaitingIncentiveModalOpen(true);
    };

    const submitWaitingIncentive = async () => {
        if (!selectedWaitingIncentiveRow) return;
        const e = enrichmentData[String(selectedWaitingIncentiveRow.id)];
        if (!e?.assignedUserId) return;

        const waitingMatchName = e.waitingMatchName || '대기학생';
        const assignedUserName = e.assignedUserName || '';
        const systemNote = `${waitingMatchName} 대기 매칭(${assignedUserName})`;

        try {
            const addResult: any = await postFetch('/dashboard/salary/addincentive', {
                userId: e.assignedUserId,
                date: new Date(waitingIncentiveDate).getTime(),
                description: '대기 인센티브',
                amount: waitingIncentiveAmount,
                systemNote,
            });
            if (addResult.message !== 'success') return;
            const insertId = addResult.insertId;

            if (selectedWaitingIncentiveRow.isWalkin) {
                await postFetch('/dashboard/report/visitConsultWaitingIncentiveMark', {
                    walkinId: selectedWaitingIncentiveRow.walkinId,
                    incentiveId: insertId,
                    addedByName: props.user?.name || '',
                });
            } else {
                await postFetch('/dashboard/report/visitConsultWaitingIncentiveMark', {
                    externalBookingId: selectedWaitingIncentiveRow.id,
                    incentiveId: insertId,
                    addedByName: props.user?.name || '',
                });
            }

            setWaitingIncentiveModalOpen(false);
            toast.success('대기 인센티브가 부여되었습니다!', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            selectedWaitingIncentiveRow.isWalkin ? loadWalkins() : loadEnrichment([selectedWaitingIncentiveRow.id]);
        } catch (err) {}
    };

    const cancelWaitingIncentive = async (incentiveId: number, row: any) => {
        if (!window.confirm('대기 인센티브를 취소하시겠습니까? 급여 내역에서도 삭제됩니다.')) return;
        try {
            await postFetch('/dashboard/salary/deleteincentive', { incentiveId });
            if (row.isWalkin) {
                await postFetch('/dashboard/report/visitConsultWaitingIncentiveClear', { walkinId: row.walkinId });
                loadWalkins();
            } else {
                await postFetch('/dashboard/report/visitConsultWaitingIncentiveClear', { externalBookingId: row.id });
                loadEnrichment([row.id]);
            }
            toast.success('대기 인센티브가 취소되었습니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
        } catch (err) {}
    };

    const autoMatch = async () => {
        // suneungsunbae 전체 방문상담 데이터 + 워크인 전체를 합쳐 최신순 500개
        let allExternalRows: any[] = [];
        try {
            const response = await fetch("https://suneungsunbae.com/api/booking/totalData", {
                method: "post",
                headers: { "Content-Type": "application/json" },
            });
            const result = await response.json();
            allExternalRows = (result.data || [])
                .filter((each: any) => each.kind === 0)
                .map((each: any) => ({
                    id: each.id,
                    phone: each.telephoneNumber,
                    isWalkin: false,
                    timeNumber: new Date(each.date).getTime(),
                }));
        } catch (e) {}

        const walkinAll = walkinRows.map((r: any) => ({
            id: r.id,
            phone: r.phone,
            isWalkin: true,
            walkinId: r.walkinId,
            timeNumber: r.timeNumber,
        }));

        const allRows = [...allExternalRows, ...walkinAll]
            .sort((a: any, b: any) => b.timeNumber - a.timeNumber);

        // enrichment에 matchedStudentId 없는 것만 (없는 키도 미매칭으로 포함)
        const unmatchedRows = allRows.filter((r: any) => {
            const e = enrichmentData[String(r.id)];
            return !e?.matchedStudentId && r.phone;
        });

        if (!unmatchedRows.length) {
            toast.info('매칭할 미연결 상담이 없습니다.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            return;
        }

        const rows = unmatchedRows.map((r: any) => ({
            rowId: String(r.id),
            phone: r.phone,
            isWalkin: !!r.isWalkin,
            walkinId: r.isWalkin ? r.walkinId : null,
            externalBookingId: !r.isWalkin ? r.id : null,
            consultDate: r.dateData
                ? `${new Date(r.dateData).getFullYear()}-${String(new Date(r.dateData).getMonth()+1).padStart(2,'0')}-${String(new Date(r.dateData).getDate()).padStart(2,'0')}`
                : getTodayStr(),
        }));

        setAutoMatchLoading(true);
        try {
            const result: any = await postFetch('/dashboard/report/visitConsultAutoMatch', { rows });
            if (result.message === 'success') {
                toast.success(`${result.matchedCount}건 자동매칭 완료!`, { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
                const externalIds = unmatchedRows.filter((r: any) => !r.isWalkin).map((r: any) => r.id);
                if (externalIds.length) loadEnrichment(externalIds);
                loadWalkins();
            }
        } catch (e) {}
        setAutoMatchLoading(false);
    };

    const openAddWalkin = () => {
        // 현재 시간 기준 30분 올림
        const now = new Date();
        const rawMinutes = now.getHours() * 60 + now.getMinutes();
        const rounded = Math.ceil(rawMinutes / 30) * 30;
        const safeMinutes = Math.min(rounded, 23 * 60 + 30);
        const defaultHour = Math.floor(safeMinutes / 60);
        const defaultMinute = safeMinutes % 60;

        // user location과 겹치는 지점 디폴트
        const matchedLoc = filteredLocations.find((l: any) => l.korean === props.user?.location);
        const defaultLocation = matchedLoc ? matchedLoc.english : '';

        setWalkinForm({
            location: defaultLocation,
            date: getTodayStr(),
            hour: defaultHour,
            minute: defaultMinute,
            name: '',
            phone: '010',
        });
        setAddWalkinOpen(true);
    };

    const submitAddWalkin = async () => {
        if (!walkinForm.location || !walkinForm.date || !walkinForm.name || !walkinForm.phone) {
            toast.error('모든 필드를 입력해주세요.', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            return;
        }
        const timeMinutes = walkinForm.hour * 60 + walkinForm.minute;
        try {
            const result: any = await postFetch('/dashboard/report/visitConsultWalkinAdd', {
                location: walkinForm.location,
                consultDate: walkinForm.date,
                timeMinutes,
                consultantName: walkinForm.name,
                phoneNumber: walkinForm.phone,
            });
            if (result.message === 'success') {
                setAddWalkinOpen(false);
                setWalkinForm({ location: '', date: getTodayStr(), hour: 9, minute: 0, name: '', phone: '010' });
                loadWalkins();
                toast.success('워크인 추가 완료!', { position: 'bottom-right', autoClose: 3000, hideProgressBar: true, theme: 'colored' });
            }
        } catch (e) {}
    };

    const deleteRow = async () => {
        if (!selectedRowId) return;
        if (!window.confirm("정말 삭제하시겠습니까?")) return;
        setLoading(true);
        try {
            if (String(selectedRowId).startsWith('w')) {
                const walkinId = +String(selectedRowId).replace('w', '');
                const result: any = await postFetch('/dashboard/report/visitConsultWalkinDelete', { walkinId });
                if (result.message === 'success') {
                    toast.success("삭제 성공!", { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" });
                    loadWalkins();
                    setSelectedRowId(null);
                }
                setLoading(false);
                return;
            }
            const response = await fetch("https://suneungsunbae.com/api/booking/parkgaeul", {
                method: "delete",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ selectionModel: [selectedRowId] })
            });
            const result = await response.json();
            if (result.message === "success") {
                toast.success("삭제 성공!", { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" });
                getBookedList();
                setSelectedRowId(null);
            }
        } catch (e) {
            toast.error("전송 실패!", { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" });
        }
        setLoading(false);
    };

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            if (newRow.isWalkin) {
                if (newRow.memo !== old.memo) {
                    postFetch('/dashboard/report/visitConsultWalkinMemo', {
                        walkinId: newRow.walkinId,
                        memo: newRow.memo || null,
                    }).catch(() => {});
                }
                return newRow;
            }
            var field = "";
            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) field = key;
            }
            const value = newRow[field] ? newRow[field] : null;
            const id = newRow.id;
            if (!field || !id) return newRow;
            try {
                fetch("https://suneungsunbae.com/api/booking/memo", {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ value, id, field })
                }).then(r => r.json()).then(() => getBookedList());
            } catch (e) {}
            return newRow;
        }, [alignment2]
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {
        alert(error.message);
    }, []);

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (!newAlignment) return;
        setAlignment(newAlignment);
        const newFilterModel = { ...filterModel };
        newFilterModel.items[0] = {
            ...newFilterModel.items[0],
            value: newAlignment === "total" ? "" : newAlignment
        };
        setFilterModel(newFilterModel);
    };

    const handleAlignmentChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (!newAlignment) return;
        setAlignment2(newAlignment);
    };

    // 방문상담 전용 컬럼
    const visitColumns = [
        {
            field: "registrationStatus",
            headerName: "등록여부",
            width: 80,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                const isRegistered = !!e?.matchedStudentId;
                return (
                    <span style={{ color: isRegistered ? '#2e7d32' : '#999', fontWeight: isRegistered ? 'bold' : 'normal' }}>
                        {isRegistered ? '등록' : '미등록'}
                    </span>
                );
            }
        },
        ...bookingColumns,
        {
            field: "consultStatus",
            headerName: "진행상태",
            width: 130,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                const status = e?.consultStatus ?? 0;
                return (
                    <Select
                        value={String(status)}
                        size="sm"
                        color={status === 0 ? 'neutral' : status === 1 ? 'success' : 'danger'}
                        variant="soft"
                        onChange={(_: any, newVal: any) => updateConsultStatus(params.row, +newVal)}
                        onClick={(ev: any) => ev.stopPropagation()}
                    >
                        <Option value="0">미선택</Option>
                        <Option value="1">진행</Option>
                        <Option value="2">미진행</Option>
                    </Select>
                );
            }
        },
        {
            field: "assign",
            headerName: "담당자",
            width: 220,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                if (e?.assignedUserId) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ fontSize: 13 }}>{e.assignedUserName}</span>
                            <Button size="sm" color="neutral" variant="soft"
                                onClick={(ev: any) => { ev.stopPropagation(); unassignConsult(e.visitConsultId, params.row.id); }}
                            >취소</Button>
                        </div>
                    );
                }
                if (e?.consultStatus === 2) return null;
                return (
                    <div style={{ display: 'flex', gap: 4 }}>
                        <Button size="sm" color="primary" variant="soft"
                            onClick={(ev: any) => { ev.stopPropagation(); assignConsult(params.row); }}
                        >담당하기</Button>
                        {props.user?.todoistApiKey && (
                            <Button size="sm" color="neutral" variant="soft"
                                onClick={(ev: any) => {
                                    ev.stopPropagation();
                                    setManualAssignRow(params.row);
                                    setSelectedTeacher(null);
                                    setManualAssignOpen(true);
                                }}
                            >수동 배정</Button>
                        )}
                    </div>
                );
            }
        },
        {
            field: "comment",
            headerName: "댓글",
            width: 80,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                const count = e?.commentCount ?? 0;
                return (
                    <div
                        onClick={(ev: any) => { ev.stopPropagation(); openCommentDrawer(params.row); }}
                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
                    >
                        {count > 0 && <span style={{ fontSize: 12 }}>{count}</span>}
                        <ChatBubbleOutlineIcon fontSize="small" />
                    </div>
                );
            }
        },
        {
            field: "waitingMatch",
            headerName: "대기 학생 매칭",
            width: 170,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                if (e?.waitingMatchId) {
                    const beforeConsult = isWaitingBeforeConsult(e, params.row);
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ color: beforeConsult ? '#bbb' : '#1565c0', fontSize: 13 }}>{e.waitingMatchName}</span>
                            <Button size="sm" color="neutral" variant="soft"
                                onClick={(ev: any) => { ev.stopPropagation(); resetWaitingMatch(params.row); }}
                            >취소</Button>
                        </div>
                    );
                }
                if (e?.consultStatus === 2) return null;
                return (
                    <Button size="sm" color="primary" variant="soft"
                        onClick={(ev: any) => { ev.stopPropagation(); openWaitingMatchModal(params.row); }}
                    >대기매칭</Button>
                );
            }
        },
        {
            field: "waitingIncentive",
            headerName: "대기 인센티브 추가",
            width: 210,
            sortable: false,
            renderCell: (params: any) => {
                if (!props.user?.todoistApiKey) return null;
                const e = enrichmentData[String(params.row.id)];
                const beforeConsult = isWaitingBeforeConsult(e, params.row);
                const canAdd = !!e?.assignedUserId && !!e?.waitingMatchId && e?.consultStatus === 1 && !beforeConsult;

                if (e?.waitingIncentiveId) {
                    const addedAt = e.waitingIncentiveAddedAt
                        ? new Date(e.waitingIncentiveAddedAt).toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
                        : '';
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
                            <span style={{ color: '#6a1b9a' }}>{addedAt} {e.waitingIncentiveAddedByName}</span>
                            <Button size="sm" color="danger" variant="soft"
                                onClick={(ev: any) => { ev.stopPropagation(); cancelWaitingIncentive(e.waitingIncentiveId, params.row); }}
                            >취소</Button>
                        </div>
                    );
                }
                if (e?.consultStatus === 2) return null;
                return (
                    <Button size="sm" color="primary" variant="soft"
                        disabled={!canAdd}
                        onClick={(ev: any) => { ev.stopPropagation(); openWaitingIncentiveModal(params.row); }}
                    >대기인센티브추가</Button>
                );
            }
        },
        {
            field: "matchedStudent",
            headerName: "등록 학생 매칭",
            width: 170,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                if (e?.matchedStudentId) {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span style={{ color: 'green', fontSize: 13 }}>{e.matchedStudentName}</span>
                            <Button size="sm" color="neutral" variant="soft"
                                onClick={(ev: any) => { ev.stopPropagation(); resetMatch(e.visitConsultId, params.row.id); }}
                            >취소</Button>
                        </div>
                    );
                }
                if (e?.consultStatus === 2) return null;
                return (
                    <Button size="sm" color="primary" variant="soft"
                        onClick={(ev: any) => { ev.stopPropagation(); openMatchModal(params.row); }}
                    >학생매칭</Button>
                );
            }
        },
        {
            field: "incentive",
            headerName: "등록 인센티브 추가",
            width: 210,
            sortable: false,
            renderCell: (params: any) => {
                const e = enrichmentData[String(params.row.id)];
                const canAdd = !!e?.assignedUserId && !!e?.matchedStudentId && e?.consultStatus === 1;

                if (e?.incentiveId) {
                    const addedAt = e.incentiveAddedAt
                        ? new Date(e.incentiveAddedAt).toLocaleString('ko-KR', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
                        : '';
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12 }}>
                            <span style={{ color: '#2e7d32' }}>{addedAt} {e.incentiveAddedByName}</span>
                            {props.user?.todoistApiKey && (
                                <Button size="sm" color="danger" variant="soft"
                                    onClick={(ev: any) => { ev.stopPropagation(); cancelIncentive(e.incentiveId, params.row); }}
                                >취소</Button>
                            )}
                        </div>
                    );
                }
                if (e?.consultStatus === 2) return null;
                return (
                    <Button size="sm" color="primary" variant="soft"
                        disabled={!canAdd}
                        onClick={(ev: any) => { ev.stopPropagation(); openIncentiveModal(params.row); }}
                    >인센티브 추가</Button>
                );
            }
        },
    ];

    return (
        <div style={{ marginBottom: "32px" }}>
            {/* 현재/과거 + 내담당상담 토글 */}
            <div style={{ marginBottom: "12px", display: "flex", alignItems: "center", gap: "16px" }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment2}
                    exclusive
                    onChange={handleAlignmentChange2}
                >
                    <ToggleButton value="current">현재내역</ToggleButton>
                    <ToggleButton value="past">과거내역</ToggleButton>
                </ToggleButtonGroup>
                <ToggleButtonGroup
                    color="primary"
                    value={myConsultFilter ? "my" : "all"}
                    exclusive
                    onChange={(_: any, v: string) => { if (v) setMyConsultFilter(v === "my"); }}
                >
                    <ToggleButton value="all">전체</ToggleButton>
                    <ToggleButton value="my">내담당상담</ToggleButton>
                </ToggleButtonGroup>
            </div>

            {/* 지점 필터 */}
            <div style={{ marginBottom: "10px" }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleAlignmentChange}
                >
                    <ToggleButton value="total">전체</ToggleButton>
                    {filteredLocations.map((loc: any) => (
                        <ToggleButton key={loc.english} value={loc.korean}>{loc.korean}</ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </div>

            {/* 방문상담 헤더 + 추가하기 + 담당자 검색 */}
            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center", justifyContent: "space-between", width: "2400px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <span style={{ fontWeight: "bold", fontSize: "15px" }}>방문상담</span>
                    <Button size="sm" color="success" variant="soft" onClick={openAddWalkin}>
                        + 워크인 추가하기
                    </Button>
                    {props.user?.todoistApiKey && (
                        <Button size="sm" color="warning" variant="soft"
                            disabled={!selectedRowId}
                            onClick={deleteRow}
                        >
                            삭제하기
                        </Button>
                    )}
                    {props.user?.todoistApiKey && (
                        <Button size="sm" color="neutral" variant="soft" onClick={autoMatch}>
                            자동매칭하기
                        </Button>
                    )}
                    {props.user?.todoistApiKey && (
                        <Button size="sm" color="primary" variant="soft" onClick={() => setStatsModalType('location')}>
                            지점별 통계보기
                        </Button>
                    )}
                    {props.user?.todoistApiKey && (
                        <Button size="sm" color="primary" variant="soft" onClick={() => setStatsModalType('assignee')}>
                            담당자별 통계보기
                        </Button>
                    )}
                </div>
                <CustomInput
                    value={assigneeSearch}
                    onChange={(e: any) => setAssigneeSearch(e.target.value)}
                    placeholder="담당자 검색"
                />
            </div>

            <div style={{ backgroundColor: "white", width: "2400px", height: "500px" }}>
                <DataGridPremium
                    rows={displayVisitRows}
                    columns={visitColumns}
                    density='compact'
                    onRowClick={(params) => setSelectedRowId(params.row.id)}
                    filterModel={filterModel}
                    onFilterModelChange={(model) => setFilterModel(model)}
                    processRowUpdate={handleEditCommit}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                />
            </div>

            {/* 댓글 SwipeableDrawer */}
            <SwipeableDrawer
                anchor="right"
                open={commentDrawerOpen}
                onClose={() => { setCommentDrawerOpen(false); setSelectedCommentVisitConsultId(null); }}
                onOpen={() => setCommentDrawerOpen(true)}
            >
                <div style={{ width: "550px", height: "100%" }}>
                    {selectedCommentVisitConsultId !== null && (
                        <ChatForOpinion
                            handleUpdate2={() => {}}
                            handleUpdate={() => {
                                const rowId = Object.keys(enrichmentData).find(
                                    k => enrichmentData[k]?.visitConsultId === selectedCommentVisitConsultId
                                );
                                if (rowId) {
                                    setEnrichmentData(prev => ({
                                        ...prev,
                                        [rowId]: { ...(prev[rowId] || {}), commentCount: (prev[rowId]?.commentCount ?? 0) + 1 }
                                    }));
                                }
                            }}
                            openControl={commentDrawerOpen}
                            user={props.user}
                            studentName={selectedCommentTitle}
                            chatRoomId={selectedCommentVisitConsultId}
                            unreadMessage={() => {}}
                            messageApiEndpoint="https://peetsunbae.com/dashboard/report/visitConsultComments"
                        />
                    )}
                </div>
            </SwipeableDrawer>

            {/* 워크인 추가 Modal */}
            <Modal open={addWalkinOpen} onClose={() => setAddWalkinOpen(false)}>
                <ModalDialog sx={{ minWidth: 400 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "16px" }}>워크인 상담 추가</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                        <FormControl>
                            <div style={{ fontSize: 13, marginBottom: 4 }}>지점</div>
                            <Select
                                value={walkinForm.location}
                                onChange={(_: any, v: any) => setWalkinForm(prev => ({ ...prev, location: v || '' }))}
                                placeholder="지점 선택"
                            >
                                {filteredLocations.map((loc: any) => (
                                    <Option key={loc.english} value={loc.english}>{loc.korean}</Option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl>
                            <div style={{ fontSize: 13, marginBottom: 4 }}>예약일</div>
                            <input
                                type="date"
                                value={walkinForm.date}
                                onChange={e => setWalkinForm(prev => ({ ...prev, date: e.target.value }))}
                                style={{ padding: "6px 8px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }}
                            />
                        </FormControl>
                        <FormControl>
                            <div style={{ fontSize: 13, marginBottom: 4 }}>예약시간</div>
                            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                                <Select
                                    value={walkinForm.hour}
                                    onChange={(_: any, v: any) => setWalkinForm(prev => ({ ...prev, hour: +v }))}
                                    sx={{ width: 90 }}
                                >
                                    {Array.from({ length: 15 }, (_, i) => i + 8).map(h => (
                                        <Option key={h} value={h}>{h}시</Option>
                                    ))}
                                </Select>
                                <Select
                                    value={walkinForm.minute}
                                    onChange={(_: any, v: any) => setWalkinForm(prev => ({ ...prev, minute: +v }))}
                                    sx={{ width: 110 }}
                                >
                                    <Option value={0}>00분</Option>
                                    <Option value={30}>30분</Option>
                                </Select>
                            </div>
                        </FormControl>
                        <FormControl>
                            <div style={{ fontSize: 13, marginBottom: 4 }}>이름</div>
                            <Input
                                value={walkinForm.name}
                                onChange={e => setWalkinForm(prev => ({ ...prev, name: e.target.value }))}
                                placeholder="상담자 이름"
                            />
                        </FormControl>
                        <FormControl>
                            <div style={{ fontSize: 13, marginBottom: 4 }}>전화번호</div>
                            <Input
                                value={walkinForm.phone}
                                onChange={e => handleWalkinPhoneChange(e.target.value)}
                                placeholder="010-0000-0000"
                            />
                        </FormControl>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 4 }}>
                            <Button variant="plain" color="neutral" onClick={() => setAddWalkinOpen(false)}>취소</Button>
                            <Button color="primary" onClick={submitAddWalkin}>저장하기</Button>
                        </div>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 수동매칭 Modal */}
            <Modal open={matchModalOpen} onClose={() => { setMatchModalOpen(false); setSelectedMatchStudent(null); }}>
                <ModalDialog sx={{ minWidth: 500 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>수동매칭</div>
                    <div style={{ fontSize: 13, color: "#666", marginBottom: "16px" }}>
                        상담자: {selectedMatchRow?.name} ({selectedMatchRow?.phone})
                    </div>
                    <Autocomplete
                        options={matchStudents}
                        value={selectedMatchStudent}
                        onChange={(_: any, newValue: any) => setSelectedMatchStudent(newValue)}
                        renderInput={(params: any) => <TextField {...params} placeholder="학생을 검색하세요" />}
                        sx={{ marginBottom: "16px" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button variant="plain" color="neutral"
                            onClick={() => { setMatchModalOpen(false); setSelectedMatchStudent(null); }}
                        >취소</Button>
                        <Button color="primary" disabled={!selectedMatchStudent} onClick={submitMatch}>
                            매칭시키기
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 수동 배정하기 Modal */}
            <Modal open={manualAssignOpen} onClose={() => { setManualAssignOpen(false); setSelectedTeacher(null); }}>
                <ModalDialog sx={{ minWidth: 460 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>담당자 수동 배정</div>
                    <div style={{ fontSize: 13, color: "#666", marginBottom: "16px" }}>
                        상담자: {manualAssignRow?.name} ({manualAssignRow?.phone})
                    </div>
                    <Autocomplete
                        options={teacherList}
                        value={selectedTeacher}
                        onChange={(_: any, newValue: any) => setSelectedTeacher(newValue)}
                        renderInput={(params: any) => <TextField {...params} placeholder="선생님을 검색하세요" />}
                        sx={{ marginBottom: "16px" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button variant="plain" color="neutral"
                            onClick={() => { setManualAssignOpen(false); setSelectedTeacher(null); }}
                        >취소</Button>
                        <Button color="primary" disabled={!selectedTeacher} onClick={submitManualAssign}>
                            배정하기
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 대기 학생 매칭 Modal */}
            <Modal open={waitingMatchModalOpen} onClose={() => { setWaitingMatchModalOpen(false); setSelectedWaitingCandidate(null); }}>
                <ModalDialog sx={{ minWidth: 520 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>대기 학생 매칭</div>
                    <div style={{ fontSize: 13, color: "#666", marginBottom: "16px" }}>
                        상담자: {selectedWaitingMatchRow?.name} ({selectedWaitingMatchRow?.phone})
                    </div>
                    <Autocomplete
                        options={waitingMatchCandidates}
                        value={selectedWaitingCandidate}
                        onChange={(_: any, newValue: any) => setSelectedWaitingCandidate(newValue)}
                        renderInput={(params: any) => <TextField {...params} placeholder="이름 또는 전화번호로 검색" />}
                        sx={{ marginBottom: "16px" }}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button variant="plain" color="neutral" onClick={() => { setWaitingMatchModalOpen(false); setSelectedWaitingCandidate(null); }}>취소</Button>
                        <Button color="primary" disabled={!selectedWaitingCandidate} onClick={submitWaitingMatch}>매칭하기</Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 대기 인센티브 Modal */}
            <Modal open={waitingIncentiveModalOpen} onClose={() => setWaitingIncentiveModalOpen(false)}>
                <ModalDialog sx={{ minWidth: 380 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>대기 인센티브 부여</div>
                    <div style={{ fontSize: 13, color: "#666", marginBottom: "16px" }}>
                        담당자: {enrichmentData[String(selectedWaitingIncentiveRow?.id)]?.assignedUserName}
                        &nbsp;({enrichmentData[String(selectedWaitingIncentiveRow?.id)]?.waitingMatchName} 대기 매칭)
                    </div>
                    <FormControl sx={{ marginBottom: "12px" }}>
                        <div style={{ fontSize: 13, marginBottom: 4 }}>날짜</div>
                        <input
                            type="date"
                            value={waitingIncentiveDate}
                            onChange={(e: any) => setWaitingIncentiveDate(e.target.value)}
                            style={{ padding: "6px 8px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }}
                        />
                    </FormControl>
                    <FormControl sx={{ marginBottom: "16px" }}>
                        <div style={{ fontSize: 13, marginBottom: 4 }}>금액</div>
                        <Input
                            type="number"
                            value={waitingIncentiveAmount}
                            onChange={(e: any) => setWaitingIncentiveAmount(+e.target.value)}
                            endDecorator="원"
                        />
                    </FormControl>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button variant="plain" color="neutral" onClick={() => setWaitingIncentiveModalOpen(false)}>취소</Button>
                        <Button color="primary" disabled={!waitingIncentiveAmount || waitingIncentiveAmount <= 0 || !waitingIncentiveDate} onClick={submitWaitingIncentive}>
                            부여하기
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {/* 인센티브 추가 Modal */}
            <Modal open={incentiveModalOpen} onClose={() => setIncentiveModalOpen(false)}>
                <ModalDialog sx={{ minWidth: 380 }}>
                    <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "8px" }}>인센티브 부여</div>
                    <div style={{ fontSize: 13, color: "#666", marginBottom: "16px" }}>
                        담당자: {enrichmentData[String(selectedIncentiveRow?.id)]?.assignedUserName}
                        &nbsp;({enrichmentData[String(selectedIncentiveRow?.id)]?.matchedStudentName} 방문상담)
                    </div>
                    <FormControl sx={{ marginBottom: "12px" }}>
                        <div style={{ fontSize: 13, marginBottom: 4 }}>날짜</div>
                        <input
                            type="date"
                            value={incentiveDate}
                            onChange={(e: any) => setIncentiveDate(e.target.value)}
                            style={{ padding: "6px 8px", border: "1px solid #ccc", borderRadius: 6, fontSize: 14 }}
                        />
                    </FormControl>
                    <FormControl sx={{ marginBottom: "16px" }}>
                        <div style={{ fontSize: 13, marginBottom: 4 }}>금액</div>
                        <Input
                            type="number"
                            value={incentiveAmount}
                            onChange={(e: any) => setIncentiveAmount(+e.target.value)}
                            endDecorator="원"
                        />
                    </FormControl>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        <Button variant="plain" color="neutral" onClick={() => setIncentiveModalOpen(false)}>취소</Button>
                        <Button color="primary" disabled={!incentiveAmount || incentiveAmount <= 0 || !incentiveDate} onClick={submitIncentive}>
                            부여하기
                        </Button>
                    </div>
                </ModalDialog>
            </Modal>

            {statsModalType && (
                <ConsultStatsModal
                    open={!!statsModalType}
                    onClose={() => setStatsModalType(null)}
                    type={statsModalType}
                    user={props.user}
                />
            )}

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={autoMatchLoading}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                    <CircularProgress color="inherit" />
                    <span style={{ fontSize: 16 }}>자동매칭 중...</span>
                </div>
            </Backdrop>
        </div>
    );
};

export default VisitConsult;
